<mat-card>
  <mat-card-title class="text-center">
   Forgot Password
  </mat-card-title>
  <mat-card-subtitle>
   
  </mat-card-subtitle>

  <form name="forgotPwdForm" [formGroup]="forgotPwdForm">
    <p  class="text-center">Please Enter Username to continue</p>
    <mat-form-field style="width: 100%;">
      <input matInput placeholder="Username" name="Username" [(ngModel)] = "username"  formControlName="emailFormControl"
     >
      <mat-error *ngIf="forgotPwdForm.controls['emailFormControl'].hasError('required')">
        Username is <strong>Required</strong>
      </mat-error>
    </mat-form-field>

    <br>
  <button mat-raised-button  [disabled]="forgotPwdForm.invalid" (click)="goto()" color="primary">Submit</button>
</form>

</mat-card>